import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "designtex" as const

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-EXR",
        exportFormat: "exr",
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-JPG",
        exportFormat: "jpeg",
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-TIFF",
        exportFormat: "tiff",
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-PNG",
        exportFormat: "png",
        exportResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-EXR",
        exportFormat: "exr",
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-JPG",
        exportFormat: "jpeg",
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-TIF",
        exportFormat: "tiff",
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-PBR-PNG",
        exportFormat: "png",
        exportResolution: "dpi72",
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_FORMATTED_ARTICLE_ID$-Tileable.$IMAGE_FORMAT$",
        options: {
            imageFormatSpelling: {
                tiff: "tif",
            },
        },
    },
]
